import Swal from 'sweetalert2'
import { QuizService } from './../../_services/quiz.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Question } from 'src/app/_models/question';
import { AuthService } from 'src/app/_services/auth.service';
import { Subscription } from './../../_models/subscription';
import { QuizEnvelop } from 'src/app/_models/quizEnvelop';
import { Component, Input, OnInit } from '@angular/core';
import { Student } from 'src/app/_models/student';

@Component({
  selector: 'app-do-question-prompt',
  templateUrl: './do-question-prompt.component.html',
  styleUrls: ['./do-question-prompt.component.css']
})
export class DoQuestionPromptComponent implements OnInit {
  @Input() quizEnvelop = new QuizEnvelop()
  @Input() learner:any={}
  @Input() subscription = new Subscription()
  @Input() subscriptionId = 0
  @Input()  question = new Question()
  hasEnrollments = false
  isPremium: false
  studentUserId: 0
  @Input() questionIndex = 0


  isLastQuestion=false


  constructor(
    public authService: AuthService,
    private router:Router,
    private route:ActivatedRoute,
    private quizService:QuizService

  ) {

  }

  ngOnInit(): void {

    this.route.params.subscribe(
      p=>{
        this.questionIndex= +p['indexValue']
        this.isLastQuestion =this.quizEnvelop.questions.length == (this.questionIndex+1)? true : false
      }
    )

  }

  markQuestion(isEndSubmit:boolean){
    let response=new QuizEnvelop()
    let answerValue=""
    this.quizService.markQuestion(this.quizEnvelop.server_quiz_envelop_id,this.question.server_question_id,answerValue,isEndSubmit).subscribe(
      x=>{
        response=x
      }
    )
    return response
  }
  onNextQuestion(){
    this.markQuestion(false)
    this.router.navigate([
      '/student/quiz/do',
      this.learner.server_user_id,
      this.quizEnvelop.server_quiz_envelop_id,
      (this.quizEnvelop.questions[this.questionIndex+1].server_question_id),
      (this.questionIndex+1)
    ])
   }
   onPreviousQuestion(){

    this.markQuestion(false)
    this.router.navigate([
      '/student/quiz/do',
      this.learner.server_user_id,
      this.quizEnvelop.server_quiz_envelop_id,
      (this.quizEnvelop.questions[this.questionIndex-1].server_question_id),
      (this.questionIndex-1)
    ])
   }

 ngAfterViewInit(){

 }
 onSaveForMarking(){
  this.showSubmitAlert()
 }
showSubmitAlert(){
  Swal.fire({
  title: '<strong>Good Job!</strong>',
  icon: 'info',
  html: 'Are you sure you want to submit for marking?',
  showCloseButton: true,
  showCancelButton: true,
  allowOutsideClick: false,
  focusConfirm: true,
  confirmButtonText:'<i class="fa fa-thumbs-up"></i> Yes',
  confirmButtonAriaLabel: 'Thumbs up, great!',
  cancelButtonText:'<i class="fa fa-thumbs-up"></i> Not Yet',
  cancelButtonAriaLabel: 'Thumbs up'
}).then((result) => {
  if (result.value) {
    this.markQuestion(this.isLastQuestion)
    this.router.navigate(['/student/quiz/review',this.learner.server_user_id,this.quizEnvelop.server_quiz_envelop_id])
  }else if(result.dismiss === Swal.DismissReason.close){
    ;
  }else{
    //window.location=continueLink
  }
})

}
}
